export interface GetDeviceListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetDeviceListPagingAndFilterResponseData
}

export interface GetDeviceListPagingAndFilterResponseData {
    items: GetDeviceListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetDeviceListPagingAndFilterResponseItem {
    deviceId: string
    no: string
    plate: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    companyId: string
    companyName: string
    phone: string
    montageKm: number
    isSelected: boolean
}

export const initialGetDeviceListPagingAndFilterResponseData: GetDeviceListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}